import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";
import api from "../../utils/api";
import { validateEmail } from "../../utils/validation";
import "./Auth.css";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validation
    if (!formData.email) {
      setError(t("forgotPassword.emailRequired"));
      return;
    }

    if (!validateEmail(formData.email)) {
      setError(t("forgotPassword.invalidEmail"));
      return;
    }

    setLoading(true);

    try {
      const response = await api.post("/auth/forgot-password", {
        email: formData.email,
      });

      setLoading(false);
      setSuccess(response.data.message || t("forgotPassword.successMessage"));
    } catch (error) {
      setLoading(false);
      const errorMessage =
        error.response?.data?.message || t("forgotPassword.genericError");
      setError(errorMessage);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Link to="/">
          <Logo />
        </Link>

        <div className="auth-card-inner">
          <h3 className="auth-card-title">{t("forgotPassword.title")}</h3>
          <p className="auth-subtitle">{t("forgotPassword.subtitle")}</p>

          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error-message">{error}</div>}

            {success && <div className="auth-success-message">{success}</div>}

            <div className="auth-form-group">
              <label htmlFor="email">{t("forgotPassword.emailLabel")}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`auth-form-input ${error && !success ? "error" : ""}`}
                placeholder={t("forgotPassword.emailPlaceholder")}
                autoComplete="email"
                disabled={loading || !!success}
              />
            </div>

            <button
              type="submit"
              className="auth-btn-primary"
              disabled={loading || !!success}
            >
              {loading
                ? t("forgotPassword.sending")
                : success
                  ? t("forgotPassword.emailSent")
                  : t("forgotPassword.sendResetLink")}
            </button>

            <div className="auth-footer">
              <span>{t("forgotPassword.rememberPassword")} </span>
              <Link to="/login" className="auth-link">
                {t("forgotPassword.backToLogin")}
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
